import { render, staticRenderFns } from "./MisawaPromotion.vue?vue&type=template&id=26fd2836&scoped=true&"
var script = {}
import style0 from "./MisawaPromotion.vue?vue&type=style&index=0&id=26fd2836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fd2836",
  null
  
)

export default component.exports